module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"specialRequests":"Special requests","done":"Done"},"zh-tw":{"specialRequests":"備註","done":"完成"}}')
  delete Component.options._Ctor
}
